<template>
    <div class="indexPage">
        <job-header-simple header_title="证件照片上传"></job-header-simple>
        <div class="uploadSection">
            <div class="item" >
                <div id="bg_front">
                    <van-uploader
                            :before-delete="beforeDeleteFront"
                            v-model="frontPicArr"
                            :max-count="1"
                            :before-read="beforeReadFront"
                    >
                        <div class="bg_front"></div>
                    </van-uploader>
                </div>
                <van-loading type="spinner" color="#6c7ef3" v-if="frontPicLoading" />
            </div>
            <div class="item" v-show="this.$route.query.papersType=='1'">
                <div id="bg_back">
                    <van-uploader
                            :before-delete="beforeDeleteBack"
                            v-model="backPicArr"
                            :max-count="1"
                            :before-read="beforeReadBack"
                    >
                        <div class="bg_back"></div>
                    </van-uploader>
                </div>
                <van-loading type="spinner" color="#6c7ef3" v-if="backPicLoading" />
            </div>

            <van-divider>照片上传要求</van-divider>
            <div class="img">
                <img src="@/assets/error_example.png" alt />
            </div>
        </div>
        <div class="btn_box">
            <van-button
                    type="info"
                    size="large"
                    @click="handleIndentify"
                    class="btn_theme"
            >上传</van-button>
        </div>
    </div>
</template>

<script>
    import {
        Uploader,
        button,
        Divider,
        Dialog,
        Toast,
        Loading,
        Overlay,
    } from "vant";
    import jobHeaderSimple from "@/components/header/header.vue";
    import Exif from "exif-js";
    import { saveIdCard } from "../../../api/employee/request"

    export default {
        components: {
            [Uploader.name]: Uploader,
            [button.name]: button,
            [Divider.name]: Divider,
            [Dialog.name]: Dialog,
            [Toast.name]: Toast,
            [Loading.name]: Loading,
            [Overlay.name]: Overlay,
            jobHeaderSimple,
        },
        data() {
            return {
                authenticationData:{
                    front:"",
                    back:"",
                    username:this.$route.query.username,
                },
                papersType:this.$route.query.papersType,
                frontPicArr: [],
                backPicArr: [],
                frontPic: "",
                backPic: "",
                frontPicLoading: false,
                backPicLoading: false,
                userId: "",
            };
        },
        mounted() {
            this.userId = this.$store.getters.userInfo.id;                                 
            this.showImage();
        },
        watch: {
            frontPicArr: function (now) {
                let that = this;
                let img = document.getElementById("bg_front");
                if (!now.length) {
                    img.style.backgroundImage = "none";
                    return;
                }
                this.imgPreview(now[0].file, function (data) {
                    that.frontPic = data;
                    img.style.backgroundImage = `url(${that.frontPic})`;
                    that.frontPicLoading = false;
                });
            },
            backPicArr: function (now) {
                let that = this;
                let img = document.getElementById("bg_back");
                if (!now.length) {
                    img.style.backgroundImage = "none";
                    return;
                }
                this.imgPreview(now[0].file, function (data) {
                    that.backPic = data;
                    img.style.backgroundImage = `url(${that.backPic})`;
                    that.backPicLoading = false;
                });
            },
        },
        methods: {
         // url 转base64
         getBase64(url, callback) {
                var Img = new Image(),
                dataURL = '';
                Img.src = url + '?v=' + Math.random();
                Img.setAttribute('crossOrigin', 'Anonymous');
                Img.onload = function() {
                    var canvas = document.createElement('canvas'),
                    width = Img.width,
                    height = Img.height;
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(Img, 0, 0, width, height);
                    dataURL = canvas.toDataURL('image/jpeg');
                    
                    return callback ? callback(dataURL) : null;
                };
            },
            beforeDeleteBack(file,detail){
                return new Promise((resolve,reject)=>{
                    this.$dialog.confirm({
                        message:'确定删除图片？'
                }).then(()=>{
                        this.backPicArr.splice(detail.index,1)
                        this.$toast.success('删除成功')
                        resolve()
                    }).catch((error)=>{
                        this.$toast.success('已取消')
                        reject(error)
                    })
                })
            },
            beforeDeleteFront(file,detail){
                return new Promise((resolve,reject)=>{
                    this.$dialog.confirm({
                        message:'确定删除图片？'
                    }).then(()=>{
                        this.frontPicArr.splice(detail.index,1)
                        this.$toast.success('删除成功')
                        resolve()
                    }).catch((error)=>{
                        this.$toast.success('已取消')
                        reject(error)
                    })
                })
            },
            showImage(){
                
                if (this.$route.query.frontUrl!=null&&this.$route.query.frontUrl!=''&&this.$route.query.frontUrl!=undefined){
                    let img = document.getElementsByClassName("bg_front");
                    img[0].style.backgroundImage=`url(${this.$route.query.frontUrl})`;
                    if( this.$route.query.frontUrl.indexOf('http') > -1){
                        this.getBase64(this.$route.query.frontUrl,dataURL=>{
                            this.frontPic  = dataURL;         
                        })
                    }else{
                        this.frontPic = this.$route.query.frontUrl;
                    }
                    
                }
                if (this.$route.query.backUrl!=null&&this.$route.query.backUrl!=''&&this.$route.query.backUrl!=undefined){
                    let imgback = document.getElementsByClassName("bg_back");
                    imgback[0].style.backgroundImage=`url(${this.$route.query.backUrl})`;
                    if( this.$route.query.backUrl.indexOf('http') > -1){
                        this.getBase64(this.$route.query.backUrl,dataURL=>{
                            this.backPic  = dataURL;         
                        })
                    }else{
                        this.backPic = this.$route.query.backUrl;
                    }
                }
            },


            beforeReadFront(file) {
                if (
                    file.type !== "image/jpeg" &&
                    file.type !== "image/png" &&
                    file.type !== "application/x-jpg" &&
                    file.type !== "image/bmp"
                ) {
                    Toast("请上传 jpg,png,jpeg,bmp 格式图片");
                    return false;
                }
                this.frontPicLoading = true;
                return true;
            },
            beforeReadBack(file) {
                if (
                    file.type !== "image/jpeg" &&
                    file.type !== "image/png" &&
                    file.type !== "application/x-jpg" &&
                    file.type !== "image/bmp"
                ) {
                    Toast("请上传 jpg,png,jpeg,bmp 格式图片");
                    return false;
                }
                this.backPicLoading = true;
                return true;
            },
            handleIndentify() {
        
                if (this.papersType=='1') {
                    if (this.frontPic == "" || this.backPic == "") {
                        Dialog.alert({
                            title: "提示",
                            message: "请确认是否上传完整的证件正反面!",
                        }).then(() => {
                        });
                        this.frontPic="";
                        this.backPic="";
                        return;
                    } else {
                        Toast.loading({
                            mask: true,
                            message: "上传中...",
                            duration: 0,
                        });
                        this.authenticationData.front=this.frontPic;
                        this.authenticationData.back=this.backPic;
                        //需要调用第三方的认证接口 this.$route.query.type===3
                        saveIdCard(this.authenticationData).then((res)=>{
                            if (res.data.status=='200'){
                                //需要修改身份信息 修改了身份证,则需要重新请求
                            // this.$store.commit('SET_USER_INFO', {})
                                   this.$store.dispatch('getUserInfo')
                                Toast.clear(res.data);
                                //如果请求后台验证成功则后台改为已认证状态，并重定向回之前页面
                                Toast.loading({
                                    duration: 3000, // 持续展示 toast
                                    forbidClick: true, // 禁用背景点击
                                    loadingType: "spinner",
                                    message: '上传成功!',
                                });
                                if(this.$route.query&&this.$route.query.type&&this.$route.query.type=='3'){
                                    this.$store.dispatch("doBosskgSign",{employeeAccountId:this.$route.query.employeeAccountId}).then(() => {
                                         this.$router.push({
                                                // 或者使用 path
                                                path: '/contractBase',
                                                query: {
                                                // 可选：传递查询参数
                                                obj: this.$route.query.contractId
                                                }
                                            })
                                    }).catch((error) => {
                                        this.$toast.fail(error);
                                    });
                                }else{ 
                                    this.$store.dispatch("doBosskgSign",{employeeAccountId: this.userId}).then(() => {
                                        this.$router.push({
                                        path: "/userInfo",
                                        });
                                    })
                                    
                                }
                               
                            }else {
                                Toast.clear();
                                Toast.fail("上传失败," + res.data.message);
                            }
                        })

                    }
                }else{
                    if (this.frontPic == "") {
                        Dialog.alert({
                            title: "提示",
                            message: "请确认是否上传证件照片!",
                        }).then(() => {
                        });
                        this.frontPic="";
                        this.backPic="";
                        return
                    } else {
                        Toast.loading({
                            mask: true,
                            message: "上传中...",
                            duration: 0,
                        });
                        this.authenticationData.front=this.frontPic;
                        this.authenticationData.back=this.backPic;
                         //需要调用第三方的认证接口 this.$route.query.type===3
                        saveIdCard(this.authenticationData).then((res)=>{
                            if (res.data.status=='200'){
                                //需要修改身份信息 修改了身份证,则需要重新请求
                                //this.$store.commit('SET_USER_INFO', {})
                                 this.$store.dispatch('getUserInfo')
                                Toast.clear();
                                //如果请求后台验证成功则后台改为已认证状态，并重定向回之前页面
                                Toast.loading({
                                    duration: 3000, // 持续展示 toast
                                    forbidClick: true, // 禁用背景点击
                                    loadingType: "spinner",
                                    message: '上传成功!',
                                });
                                if(this.$route.query&&this.$route.query.type&&this.$route.query.type=='3'){

                                    this.$store.dispatch("doBosskgSign",{employeeAccountId:this.$route.query.employeeAccountId}).then(() => {
                                         this.$router.push({
                                                // 或者使用 path
                                                path: '/contractBase',
                                                query: {
                                                // 可选：传递查询参数
                                                obj: this.$route.query.contractId
                                                }
                                            })
                                    }).catch((error) => {
                                        this.$toast.fail(error);
                                    });
                                }else{ 

                                      this.$store.dispatch("doBosskgSign",{employeeAccountId: this.userId}).then(() => {
                                         this.$router.push({
                                            path: "/userInfo",
                                        });
                                     })
                                  
                                }
                            
                            }else {
                                Toast.clear();
                                Toast.fail("上传失败," + res.data.message);
                            }
                        })

                    }
                }
            },
            imgPreview(file, callback) {
                let self = this;
                let Orientation;
                //去获取拍照时的信息，解决拍出来的照片旋转问题
                Exif.getData(file, function () {
                    Orientation = Exif.getTag(this, "Orientation");
                });
                // 看支持不支持FileReader
                if (!file || !window.FileReader) return;

                if (/^image/.test(file.type)) {
                    // 创建一个reader
                    let reader = new FileReader();
                    // 将图片2将转成 base64 格式
                    reader.readAsDataURL(file);
                    // 读取成功后的回调
                    reader.onloadend = function () {
                        let result = this.result;
                        let img = new Image();
                        img.src = result;
                        //判断图片是否大于100K,是就直接上传，反之压缩图片
                        if (this.result.length <= 100 * 1024) {
                            callback(this.result);
                        } else {
                            img.onload = function () {
                                let data = self.compress(img, Orientation);
                                callback(data);
                            };
                        }
                    };
                }
            },
            compress(img, Orientation) {
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext("2d");
                //瓦片canvas
                let tCanvas = document.createElement("canvas");
                let tctx = tCanvas.getContext("2d");
                //let initSize = img.src.length;
                let width = img.width;
                let height = img.height;
                //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
                let ratio;
                if ((ratio = (width * height) / 4000000) > 1) {
                    //console.log("大于400万像素");
                    ratio = Math.sqrt(ratio);
                    width /= ratio;
                    height /= ratio;
                } else {
                    ratio = 1;
                }
                canvas.width = width;
                canvas.height = height;
                //        铺底色
                ctx.fillStyle = "#fff";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                //如果图片像素大于100万则使用瓦片绘制
                let count;
                if ((count = (width * height) / 1000000) > 1) {
                    //console.log("超过100W像素");
                    count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
                    //            计算每块瓦片的宽和高
                    let nw = ~~(width / count);
                    let nh = ~~(height / count);
                    tCanvas.width = nw;
                    tCanvas.height = nh;
                    for (let i = 0; i < count; i++) {
                        for (let j = 0; j < count; j++) {
                            tctx.drawImage(
                                img,
                                i * nw * ratio,
                                j * nh * ratio,
                                nw * ratio,
                                nh * ratio,
                                0,
                                0,
                                nw,
                                nh
                            );
                            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                        }
                    }
                } else {
                    ctx.drawImage(img, 0, 0, width, height);
                }
                //修复ios上传图片的时候 被旋转的问题
                if (Orientation != "" && Orientation != 1) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            this.rotateImg(img, "left", canvas);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            this.rotateImg(img, "right", canvas);
                            break;
                        case 3: //需要180度旋转
                            this.rotateImg(img, "right", canvas); //转两次
                            this.rotateImg(img, "right", canvas);
                            break;
                    }
                }
                //进行最小压缩
                let ndata = canvas.toDataURL("image/jpeg", 0.1);
                tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
                return ndata;
            },
            rotateImg(img, direction, canvas) {
                //最小与最大旋转方向，图片旋转4次后回到原方向
                const min_step = 0;
                const max_step = 3;
                if (img == null) return;
                //img的高度和宽度不能在img元素隐藏后获取，否则会出错
                let height = img.height;
                let width = img.width;
                let step = 2;
                if (step == null) {
                    step = min_step;
                }
                if (direction == "right") {
                    step++;
                    //旋转到原位置，即超过最大值
                    step > max_step && (step = min_step);
                } else {
                    step--;
                    step < min_step && (step = max_step);
                }
                //旋转角度以弧度值为参数
                let degree = (step * 90 * Math.PI) / 180;
                let ctx = canvas.getContext("2d");
                switch (step) {
                    case 0:
                        canvas.width = width;
                        canvas.height = height;
                        ctx.drawImage(img, 0, 0);
                        break;
                    case 1:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.rotate(degree);
                        ctx.drawImage(img, 0, -height);
                        break;
                    case 2:
                        canvas.width = width;
                        canvas.height = height;
                        ctx.rotate(degree);
                        ctx.drawImage(img, -width, -height);
                        break;
                    case 3:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.rotate(degree);
                        ctx.drawImage(img, -width, 0);
                        break;
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    .uploadSection {
        margin: 8px 12px;
        background: #fff;
        padding: 28px 20px 10px;
        .item {
            position: relative;
            width: 250px;
            height: 122px;
            background: #ebecf4;
            border-radius: 2px;
            margin: 0 auto 18px;
            text-align: center;
            padding: 11px;

            & > div {
                height: 122px;
                background-position: center center;
                background-size: contain;
                background-repeat: no-repeat;
            }

            .van-loading {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                padding-top: 55px;
                background: rgba(0, 0, 0, 0.6);
            }

            /deep/ .van-uploader {
                height: 122px;
                //overflow: hidden;
            }

            /deep/ .van-uploader__preview {
                margin: 0;
            }

            /deep/ .van-uploader__preview-image {
                max-width: 250px;
                max-height: 122px;
                width: auto;
                height: auto;
                text-align: center;
            }

            /deep/ .van-image__img {
                display: inline-block;
                opacity: 0;
                max-width: 100%;
                max-height: 100%;
                width: auto;
                height: auto;
            }
        }
    }

    .bg_front {
        display: block;
        width: 193px;
        height: 121px;
        background: url("../../../assets/bg_front.png") center center no-repeat;
        background-size: contain;
    }

    .loading {
        z-index: 99999;
        margin-left: auto;
        margin-right: auto;
    }

    .bg_back {
        display: block;
        width: 193px;
        height: 121px;
        margin: 0 auto;
        background: url("../../../assets/bg_back.png") center center no-repeat;
        background-size: contain;
    }

    .img {
        margin-top: -10px;
        img {
            display: block;
            width: 100%;
            height: auto;
        }
    }

    .btn_box {
        padding: 38px 44px;
    }
</style>